import { InfoboxComponent } from './infobox.component';

export { InfoboxComponent };
